import { createFileRoute, Link } from '@tanstack/react-router'
import { Lightbulb, Plus } from 'lucide-react'
import { isFeatureEnabled } from '@/lib/feature-flags'
import { GatedFeaturePlaceholder } from '@/components/GatedFeaturePlaceholder'
import ErrorFallback from '@/components/ErrorFallback'
import { Button } from '@/components/ui/button'
import { EmptyState } from '@/components/ui/empty-state'
import { PageBody, PageContainer } from '@/components/ui/page-container'
import { PageHeader } from '@/components/ui/page-header'

export const Route = createFileRoute('/_authenticated/projects/$projectSlug/prompts')({
  component: ProjectPromptsPage,
  errorComponent: ErrorFallback,
})

export function ProjectPromptsPage() {
  const { projectSlug } = Route.useParams()

  if (!isFeatureEnabled('collab')) {
    return (
      <GatedFeaturePlaceholder
        title="Prompt Library"
        description="Reusable instructions that teammates or the agent can run against any document."
        icon={Lightbulb}
        flagName="VITE_FF_COLLAB"
      />
    )
  }

  return (
    <PageContainer>
      <PageHeader
        eyebrow="Project"
        title="Prompt Library"
        description="Reusable instructions scoped to this project. Anyone with access can run them."
        actions={
          <Button size="sm" variant="outline" disabled>
            <Plus />
            New prompt
          </Button>
        }
      />
      <PageBody>
        <EmptyState
          icon={Lightbulb}
          title="No prompts yet"
          description="Create a prompt to share a reusable instruction with your team."
          action={
            <Button asChild size="sm" variant="outline">
              <Link to="/projects/$projectSlug" params={{ projectSlug }}>
                Back to project
              </Link>
            </Button>
          }
        />
      </PageBody>
    </PageContainer>
  )
}
